import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function AdminUpdateRequests() {
  const [updateRequests, setUpdateRequests] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const adminId = localStorage.getItem('playerId');

  useEffect(() => {
    if (!adminId) return;
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/admin/update-requests`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error(await res.text());
        setUpdateRequests(await res.json() || []);
      } catch (error) {
        setMessage('Error loading update requests: ' + error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [adminId]);

  const handleRequest = async (requestId, status, denyReason = '') => {
    try {
      const res = await fetch(`${API_BASE_URL}/admin/update-request/${requestId}`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ status, denyReason })
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setUpdateRequests(updateRequests.filter(r => r._id !== requestId));
      setMessage(data.message);
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  if (!adminId) return <p style={{ textAlign: 'center', color: '#333' }}>Please log in as an admin.</p>;
  if (loading) return <p style={{ textAlign: 'center', color: '#333' }}>Loading update requests...</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>Update Requests</h1>
      {message && <p style={{ textAlign: 'center', color: message.includes('Error') ? '#FF4444' : '#4CAF50' }}>{message}</p>}

      <h2 style={{ color: '#4CAF50', marginBottom: '15px' }}>Pending Update Requests</h2>
      {updateRequests.length > 0 ? (
        updateRequests.map(req => (
          <div key={req._id} style={{ marginBottom: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
            <p>Dog ID: <Link to={`/dog/${req.dogId}`} style={{ color: '#4CAF50' }}>{req.dogId}</Link></p>
            <p>Field: {req.field}</p>
            <p>New Value: <a href={req.newValue} target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50' }}>{req.newValue}</a></p>
            <p>Submitted: {new Date(req.submittedAt).toLocaleString()}</p>
            <div style={{ marginTop: '10px' }}>
              <button onClick={() => handleRequest(req._id, 'Approved')} style={{ background: '#4CAF50', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '3px', marginRight: '10px' }}>Approve</button>
              <button onClick={() => {
                const reason = prompt('Enter deny reason:');
                if (reason) handleRequest(req._id, 'Denied', reason);
              }} style={{ background: '#FF69B4', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '3px' }}>Deny</button>
            </div>
          </div>
        ))
      ) : <p style={{ textAlign: 'center', color: '#888' }}>No pending update requests.</p>}
    </div>
  );
}

export default AdminUpdateRequests;